import {JsonPipe} from '@angular/common';
import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-canvas',
    imports: [
        JsonPipe
    ],
  templateUrl: './iackathon-step-canvas.component.html',
  styleUrl: './iackathon-step-canvas.component.scss',
})
export class IackathonStepCanvasComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    protected canvas = computed(() => this.state().odd_canvas_step);

}
